/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncludeForm { 
    policy?: boolean;
    graduatoria?: boolean;
    attributi_e_valori?: boolean;
    comunicazioni?: boolean;
    istituti_e_plessi?: boolean;
    regole_punteggio?: boolean;
    template_form_cittadino?: boolean;
    servizi?: boolean;
    articoli_cedole?: boolean;
}

